module.exports = __webpack_public_path__ + "assets/img/1512_04.jpg?c9968e79dae80c96ad4cbf29be34a6a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1512_04.jpg
// module id = 1094
// module chunks = 0